"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROGRAM = exports.ATTENDEE_ROSTER = exports.ATTENDEE_DETAILS = void 0;
var PROGRAM = exports.PROGRAM = 'PROGRAM';
var ATTENDEE_ROSTER = exports.ATTENDEE_ROSTER = 'ATTENDEE_ROSTER';
var ATTENDEE_DETAILS = exports.ATTENDEE_DETAILS = 'ATTENDEE_DETAILS';